import classNames from 'classnames';
import styles from './LoadingSkeleton.module.css';
import type { LoadingSkeletonProps } from './types';
function LoadingSkeleton({
  as: Tag = 'div',
  width,
  height,
  borderRadius,
  style,
  className,
  dark,
  ...props
}: LoadingSkeletonProps) {
  return <Tag className={classNames(styles.skeleton, className, {
    [styles.dark!]: dark
  })} style={{
    width,
    height,
    borderRadius,
    ...style
  }} {...props}></Tag>;
}
export default LoadingSkeleton;